<template>

    <li>
      <label :for="'selectInvoice' + client.clientId">            
            
        <p class="mdc-typography--headline5">
          {{client.clubName}}
        </p>
        <p class="mdc-typography--headline6 outstanding-amount">
          {{formatMoney(client.outstandingInvoice.amount_due)}}
        </p>
        <div class="mdc-checkbox" v-if="outstandingSubscriptionInvoices.length > 1">
          <input type="checkbox"
                :value="client"
                class="mdc-checkbox__native-control"
                
                v-model="selectedInvoicesToPay"
                 />
          <div class="mdc-checkbox__background">
            <svg class="mdc-checkbox__checkmark"
                 viewBox="0 0 24 24">
              <path class="mdc-checkbox__checkmark-path"
                    fill="none"
                    d="M1.73,12.91 8.1,19.28 22.79,4.59"/>
            </svg>
            <div class="mdc-checkbox__mixedmark"></div>
          </div>
        </div>

      </label>
    </li>   
</template>
<script>
import { formatMoney } from "&/helpers.js";
import { mapGetters } from 'vuex';



export default {
  name: 'SelectOutstandingSubscriptionInvoiceToPayListItem',
  data() {
    return {

    };
  },
  props: {
    client: {
      type: Object,
      required: true
    }
  },

  computed: {

    ...mapGetters(['outstandingSubscriptionInvoices']),

    selectedInvoicesToPay : {
      get(){
        return this.$store.getters.selectedInvoicesToPay
      },
      set(value){
        return this.$store.commit('UPDATED_SELECTED_OUTSTANDING_INVOICES', value)
      }
    }
  },

  methods: {
    formatMoney(value) {
      return formatMoney(value);
    }
  },

  async created() {

  },

  components: {
 
  }
};
</script>

<style lang="scss" scoped>
@import "%/scss/_Color.sass";


li {
  list-style: none;
  width: 100%;
  border-bottom: 1px solid #efefef;

  label {
    display: grid;
    grid-template-columns: 3fr 3fr 2fr; 

    .mdc-checkbox {
      align-items: center;
      margin: 0 auto;
  }

  }

}

p {
  margin-bottom: 8px;
}

.outstanding-amount {
  color: $color-alert;
  text-align: right;
}


</style>
